import { useLocale } from "../../../hooks/useLocale";
import type { Quote } from "../types";
import { Coverage } from "./Coverage";
import { filterCovers } from "./filterCovers";
import { Header } from "./Header";
import { HeaderUK } from "./Header/HeaderUK";
import { NoQuoteCard } from "./NoQuoteCard/NoQuoteCard";
import { Pricing } from "./Pricing";
import { Pricing as PricingUK } from "./PricingUK/Pricing";
import { QuoteActions } from "./QuoteActions";

export type QuoteCardProps = {
  hideNoQuoteCard?: boolean;
  quote: Quote;
  variant?: string;
};

export const QuoteCard = ({
  quote,
  variant,
  hideNoQuoteCard,
}: QuoteCardProps) => {
  const { status, helpText } = quote;
  const insurer = quote.covers[0]?.coverInsurer;
  const insurerParametrized = insurer?.toLowerCase().replaceAll(" ", "-");
  const chopinTestId = `buy-${insurerParametrized}-block`;
  const { isUK } = useLocale();
  const filteredCovers = filterCovers(quote);
  const quoteCardClass = "mobius-quote-card";

  if (status === "referred") {
    if (hideNoQuoteCard === true) {
      return <></>;
    }

    return <NoQuoteCard insurer={insurer} insurerLogo={quote.insurerLogo} />;
  }

  return (
    <div
      role="listitem"
      className={quoteCardClass}
      id={chopinTestId}
      data-testid="quote-cards-list-item"
    >
      {isUK ? (
        <HeaderUK
          logo={quote.insurerLogo}
          insurerName={quote.insurerNameParametrized}
          underWriterText={quote.underwriter}
        />
      ) : (
        <Header
          logo={quote.insurerLogo}
          insurerName={quote.insurerNameParametrized}
          insurerFinancialStrengthRatings={quote.ratings}
          offlinePurchaseOnly={quote.offlinePurchaseOnly}
          offlinePurchaseOnlyText={quote.offlinePurchaseOnlyText}
          offlinePurchaseOnlyNumber={quote.offlinePurchaseOnlyNumber}
          offlinePurchaseOnlyRfq={quote.offlinePurchaseOnlyRfq}
        />
      )}
      {isUK ? (
        <PricingUK quote={quote} displayBadges showInstallmentsInformation />
      ) : (
        <Pricing quote={quote} displayBadges showInstallmentsInformation />
      )}
      <Coverage
        helpText={helpText}
        covers={filteredCovers}
        additionalCoverage={quote.additionalCoverage}
        displayVariant="qcp"
        withModal
        variant={variant}
        upsells={quote.upsells}
      />
      <QuoteActions quote={quote} variant={variant} />
    </div>
  );
};
